import { Link } from "react-router-dom";
import { useBasket } from "../basket/BasketContext";
import { DeliveryNotice } from "../components/DeliveryNotice";
import { EmptyState } from "../components/EmptyState";
import { Seo } from "../components/Seo";
import { formatGbp } from "../lib/money";

export function BasketPage() {
  const { items, subtotalGbp, setQuantity, remove, clear } = useBasket();

  return (
    <main id="main" className="page">
      <Seo
        title="Basket"
        description="Your Beautiful Jewellery basket."
        path="/basket"
      />
      <p className="kicker">Basket</p>
      <h1>Basket</h1>
      <DeliveryNotice />
      {items.length === 0 ? (
        <>
          <EmptyState title="Your basket is empty">
            Shopping is not available yet.
          </EmptyState>
          <p>
            <Link to="/collections">See the collection</Link>
          </p>
        </>
      ) : (
        <>
          <table className="basket-table">
            <thead>
              <tr>
                <th scope="col">Piece</th>
                <th scope="col">Price</th>
                <th scope="col">Quantity</th>
                <th scope="col">Line total</th>
                <th scope="col">
                  <span className="visually-hidden">Remove</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.productId}>
                  <td>
                    <Link to={`/products/${item.slug}`}>{item.name}</Link>
                  </td>
                  <td>{formatGbp(item.priceGbp)}</td>
                  <td>
                    <label>
                      <span className="visually-hidden">Quantity for {item.name}</span>
                      <input
                        className="qty"
                        type="number"
                        min={1}
                        inputMode="numeric"
                        value={item.quantity}
                        onChange={(event) =>
                          setQuantity(item.productId, Number(event.target.value))
                        }
                      />
                    </label>
                  </td>
                  <td>{formatGbp(item.priceGbp * item.quantity)}</td>
                  <td>
                    <button
                      className="button-ghost"
                      type="button"
                      onClick={() => remove(item.productId)}
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="basket-summary">
            <p>Subtotal {formatGbp(subtotalGbp)}</p>
            <p className="quiet-note" role="status">
              Shopping is not available yet.
            </p>
            <div className="actions">
              <button className="button" type="button" disabled>
                Checkout unavailable
              </button>
              <button className="button-ghost" type="button" onClick={clear}>
                Clear basket
              </button>
            </div>
          </div>
        </>
      )}
    </main>
  );
}
